import PrisyncLogo from '@Icons/prisync-logo.svg?react'

function ErrorLayout({
  children,
}: {
  children?: React.ReactNode
}): JSX.Element {
  return (
    <div className="container mx-auto h-full">
      <div className="flex justify-center container mx-auto h-full py-12">
        <div className="flex flex-col items-center w-96">
          <PrisyncLogo />
        </div>
      </div>
      <div className="flex flex-col items-center">{children}</div>
    </div>
  )
}

export default ErrorLayout
